<template>
  <section>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="160px">
      <!-- 验证码 -->
      <section slot="verifyCode" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.verifyCode">
          <article
            class="getCodeBtn"
            :class="{
              primary: !smsTime,
              cur: !smsTime,
              blur: smsTime,
            }"
            slot="suffix"
            @click="getSms"
          >{{ smsTime || '获取短信验证码' }}</article>
        </el-input>
      </section>
    </qx-custom-form>
  </section>
</template>

<script>
import { sendValidCode, checkValidCode, checkPhone } from 'api';
import {
  getAddressOptions,
  findAddressName,
} from '@qx/utils';
export default {
  data () {
    return {
      checkPhoneNum: true,
      smsTime: 0,
      smsTimer: null,
      baseForm: {
        form: [
          {
            label: '手机号码',
            value: 'linkPhone',
            type: 'input',
            onBlur: () => {
              this.checkPhone();
            },
          },
          {
            label: '验证码',
            value: 'verifyCode',
            slot: true,
          },
          {
            label: '营业执照',
            value: 'businessLicense',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
            attr: {
              limit: 1,
            },
          },
          {
            label: '企业名称',
            value: 'companyName',
            type: 'input',
          },
          {
            label: '社会信用代码',
            value: 'businessLicenseNo',
            type: 'input',
          },
          {
            label: '营业执照住所',
            value: 'companyPos',
            type: 'cascader',
            default: [],
            options: getAddressOptions({
              showLevel: 1,
            }),
          },
          {
            label: '营业执照详细地址',
            value: 'companyAddress',
            type: 'input',
          },
          {
            label: '常用办公地址',
            value: 'workPos',
            type: 'cascader',
            default: [],
            options: getAddressOptions({
              showLevel: 1,
            }),
          },
          {
            label: '常用办公详细地址',
            value: 'address',
            type: 'input',
          },
        ],
        rules: {
          linkPhone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
          ],
          verifyCode: [
            { required: true, message: '请输入手机验证码', trigger: 'blur' },
          ],
          businessLicense: [
            { required: true, message: '请上传营业执照', trigger: 'blur' },
          ],
          companyName: [
            { required: true, message: '请输入企业名称', trigger: 'blur' },
          ],
          businessLicenseNo: [
            { required: true, message: '请输入社会信用代码', trigger: 'blur' },
          ],
          companyPos: [
            { required: true, message: '请输入营业执照住所', trigger: 'blur' },
          ],
          companyAddress: [
            { required: true, message: '请输入营业执照详细地址', trigger: 'blur' },
          ],
          workPos: [
            { required: true, message: '请输入办公常用地址', trigger: 'blur' },
          ],
          address: [
            { required: true, message: '请输入办公常用详细地址', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async checkPhone () {
      const linkPhone = this.$refs.baseForm.getVal('linkPhone');
      if (!(/^\d{11}$/.test(linkPhone))) {
        this.$message.warning('亲，请输入正确的手机号码！');
        return;
      }
      const res = await checkPhone({
        phone: linkPhone,
      });
      if (res === 'Y') {
        this.checkPhoneNum = false;
        this.$message.warning('该手机号码已被注册，请更换！');
      }
    },
    async getSms () { // 获取短信验证码
      const phone = await this.$refs.baseForm.getVal('linkPhone');
      if (!this.checkPhoneNum) {
        this.$message.warning('该手机号码已被注册，请更换！');
        return;
      }
      if (!(/^\d{11}$/.test(phone))) {
        this.$message.warning('亲，请输入正确的手机号码！');
        return;
      }
      if (this.smsTime > 0) {
        return;
      }
      this.smsTime = 20;
      const res = await sendValidCode({
        phone,
      });
      if (!res.failed) {
        this.$message.success('验证码已发送，请可留意查收');
        clearInterval(this.smsTimer);
        this.smsTimer = setInterval(() => {
          this.smsTime--;
          if (this.smsTime <= 0) {
            this.smsTime = 0;
            clearInterval(this.smsTimer);
          }
        }, 1000);
      } else {
        this.smsTime = 0;
      }
    },
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        if (formData.linkPhone && formData.verifyCode) {
          const resCheckValidCode = await checkValidCode({
            phone: formData.linkPhone,
            verifyCode: formData.verifyCode,
          });
          if (resCheckValidCode === 'N') {
            this.$message.error('验证码错误！请输入正确的验证码！');
            return null;
          }
        }
        if (formData.companyPos && formData.companyPos.length) {
          // 营业执照住所-省
          formData.companyProvinceId = formData.companyPos[0];
          // 营业执照住所-市
          formData.companyCityId = formData.companyPos[1];
          // 营业执照住所-区
          formData.companyDistrictId = formData.companyPos[2];
          const addressName = await findAddressName({
            arr: formData.companyPos,
          });
          formData.companyProvinceName = addressName[0];
          formData.companyCityName = addressName[1];
          formData.companyDistrictName = addressName[2];
          delete formData.companyPos;
        }
        if (formData.workPos && formData.workPos.length) {
          // 办公常用地址-省
          formData.provinceId = formData.workPos[0];
          // 办公常用地址-市
          formData.cityId = formData.workPos[1];
          // 办公常用地址-区
          formData.districtId = formData.workPos[2];
          const addressName = await findAddressName({
            arr: formData.workPos,
          });
          formData.provinceName = addressName[0];
          formData.cityName = addressName[1];
          formData.districtName = addressName[2];
          delete formData.workPos;
        }
        if (formData.businessLicense && formData.businessLicense.length) {
          formData.businessLicense = formData.businessLicense[0].id;
        }
        console.log(formData);
      }
      return formData;
    },
  },
};
</script>

<style lang="scss" scoped>
.getCodeBtn {
  margin-right: 10px;
}
</style>
